<div class="ob1-snackbar" [ngClass]="{ show: show }" aria-atomic="true" role="alert" aria-live="assertive">
  <div class="ob1-snackbar-wrapper">
    <span class="ob1-snackbar-icon {{ style }}" aria-hidden="true"></span>
    <p class="ob1-snackbar-label">{{ text }}</p>
  </div>
  @if (linkAttributes) {
    <a
      class="ob1-snackbar-link ob1-link-icon o-link-reverse"
      href="{{ linkAttributes.url }}"
      (click)="materialSnackBarLink(); (false)"
      >
      <span class="icon icon-checkbox-tick" aria-hidden="true"></span>
      <span class="ob1-link-icon-text">{{ linkAttributes.label }}</span>
    </a>
  }
</div>
